import React, { useRef, useState } from 'react';
import { Download, Image, Square, Circle, Twitter, Facebook, Instagram, Linkedin, Youtube, CheckCircle } from 'lucide-react';

// Logo SVG Component - Complete logo with text
const LogoFull = ({ size = 400 }) => (
  <svg width={size} height={size * 0.35} viewBox="0 0 400 140" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Background */}
    <rect width="400" height="140" fill="transparent" />
    
    {/* Logo Icon */}
    <g transform="translate(20, 10)">
      <circle cx="60" cy="60" r="56" fill="url(#linceGradientFull)" />
      
      {/* Lince Ibérico face */}
      <ellipse cx="60" cy="56" rx="38" ry="30" fill="#D4A574" />
      
      {/* Ear tufts */}
      <path d="M30 26L22 4L38 22Z" fill="#8B5A2B" />
      <path d="M90 26L98 4L82 22Z" fill="#8B5A2B" />
      <path d="M30 26L25 12L36 22Z" fill="#2D1B0E" />
      <path d="M90 26L95 12L84 22Z" fill="#2D1B0E" />
      
      {/* Inner ears */}
      <path d="M32 30L27 14L40 26Z" fill="#F4D6B8" />
      <path d="M88 30L93 14L80 26Z" fill="#F4D6B8" />
      
      {/* Cheek fur */}
      <path d="M22 52Q14 60 18 76Q26 72 30 60Z" fill="#C4956A" />
      <path d="M98 52Q106 60 102 76Q94 72 90 60Z" fill="#C4956A" />
      
      {/* White patches */}
      <ellipse cx="45" cy="52" rx="12" ry="14" fill="#F5E6D3" />
      <ellipse cx="75" cy="52" rx="12" ry="14" fill="#F5E6D3" />
      
      {/* Eyes */}
      <ellipse cx="45" cy="50" rx="8" ry="10" fill="#F59E0B" />
      <ellipse cx="75" cy="50" rx="8" ry="10" fill="#F59E0B" />
      <circle cx="45" cy="50" r="5" fill="#1E293B" />
      <circle cx="75" cy="50" r="5" fill="#1E293B" />
      <circle cx="47" cy="48" r="2" fill="white" />
      <circle cx="77" cy="48" r="2" fill="white" />
      
      {/* Nose */}
      <path d="M60 62L55 68L60 72L65 68Z" fill="#2D1B0E" />
      
      {/* Mouth */}
      <path d="M60 72V76" stroke="#2D1B0E" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M52 78Q60 84 68 78" stroke="#2D1B0E" strokeWidth="1.5" fill="none" strokeLinecap="round" />
      
      {/* Spots */}
      <circle cx="34" cy="44" r="3" fill="#8B5A2B" />
      <circle cx="86" cy="44" r="3" fill="#8B5A2B" />
      <circle cx="38" cy="64" r="2" fill="#8B5A2B" />
      <circle cx="82" cy="64" r="2" fill="#8B5A2B" />
      
      {/* Whiskers */}
      <path d="M34 66L14 62" stroke="#2D1B0E" strokeWidth="1" strokeLinecap="round" />
      <path d="M34 70L12 72" stroke="#2D1B0E" strokeWidth="1" strokeLinecap="round" />
      <path d="M34 74L16 82" stroke="#2D1B0E" strokeWidth="1" strokeLinecap="round" />
      <path d="M86 66L106 62" stroke="#2D1B0E" strokeWidth="1" strokeLinecap="round" />
      <path d="M86 70L108 72" stroke="#2D1B0E" strokeWidth="1" strokeLinecap="round" />
      <path d="M86 74L104 82" stroke="#2D1B0E" strokeWidth="1" strokeLinecap="round" />
      
      {/* Graduation cap */}
      <path d="M60 14L30 30L60 46L90 30Z" fill="#1E293B" />
      <rect x="56" y="10" width="8" height="8" fill="#F59E0B" />
      <path d="M64 10L72 2L80 10" fill="#F59E0B" stroke="#F59E0B" strokeWidth="1.5" />
    </g>
    
    {/* Text */}
    <text x="160" y="85" fontFamily="Arial Black, Arial, sans-serif" fontSize="48" fontWeight="900" fill="url(#textGradient)">
      TuPlazaIA
    </text>
    
    <defs>
      <linearGradient id="linceGradientFull" x1="0" y1="0" x2="120" y2="120" gradientUnits="userSpaceOnUse">
        <stop stopColor="#6366F1" />
        <stop offset="1" stopColor="#8B5CF6" />
      </linearGradient>
      <linearGradient id="textGradient" x1="160" y1="50" x2="380" y2="90" gradientUnits="userSpaceOnUse">
        <stop stopColor="#6366F1" />
        <stop offset="1" stopColor="#8B5CF6" />
      </linearGradient>
    </defs>
  </svg>
);

// Icon only
const LogoIcon = ({ size = 200 }) => (
  <svg width={size} height={size} viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="100" cy="100" r="95" fill="url(#linceGradientIcon)" />
    
    {/* Lince face */}
    <ellipse cx="100" cy="94" rx="62" ry="50" fill="#D4A574" />
    
    {/* Ear tufts */}
    <path d="M50 44L36 8L66 36Z" fill="#8B5A2B" />
    <path d="M150 44L164 8L134 36Z" fill="#8B5A2B" />
    <path d="M50 44L42 20L60 36Z" fill="#2D1B0E" />
    <path d="M150 44L158 20L140 36Z" fill="#2D1B0E" />
    
    {/* Inner ears */}
    <path d="M54 50L45 24L66 42Z" fill="#F4D6B8" />
    <path d="M146 50L155 24L134 42Z" fill="#F4D6B8" />
    
    {/* Cheek fur */}
    <path d="M36 86Q24 100 30 126Q42 120 50 100Z" fill="#C4956A" />
    <path d="M164 86Q176 100 170 126Q158 120 150 100Z" fill="#C4956A" />
    
    {/* White patches */}
    <ellipse cx="75" cy="86" rx="19" ry="22" fill="#F5E6D3" />
    <ellipse cx="125" cy="86" rx="19" ry="22" fill="#F5E6D3" />
    
    {/* Eyes */}
    <ellipse cx="75" cy="82" rx="12" ry="16" fill="#F59E0B" />
    <ellipse cx="125" cy="82" rx="12" ry="16" fill="#F59E0B" />
    <circle cx="75" cy="82" r="8" fill="#1E293B" />
    <circle cx="125" cy="82" r="8" fill="#1E293B" />
    <circle cx="79" cy="78" r="3" fill="white" />
    <circle cx="129" cy="78" r="3" fill="white" />
    
    {/* Nose */}
    <path d="M100 102L92 114L100 120L108 114Z" fill="#2D1B0E" />
    
    {/* Mouth */}
    <path d="M100 120V128" stroke="#2D1B0E" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M86 132Q100 142 114 132" stroke="#2D1B0E" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    
    {/* Spots */}
    <circle cx="56" cy="72" r="5" fill="#8B5A2B" />
    <circle cx="144" cy="72" r="5" fill="#8B5A2B" />
    <circle cx="62" cy="106" r="3" fill="#8B5A2B" />
    <circle cx="138" cy="106" r="3" fill="#8B5A2B" />
    
    {/* Whiskers */}
    <path d="M56 108L24 100" stroke="#2D1B0E" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M56 116L20 118" stroke="#2D1B0E" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M56 122L26 136" stroke="#2D1B0E" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M144 108L176 100" stroke="#2D1B0E" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M144 116L180 118" stroke="#2D1B0E" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M144 122L174 136" stroke="#2D1B0E" strokeWidth="1.5" strokeLinecap="round" />
    
    {/* Graduation cap */}
    <path d="M100 24L50 50L100 76L150 50Z" fill="#1E293B" />
    <rect x="92" y="16" width="16" height="16" fill="#F59E0B" />
    <path d="M108 16L120 4L132 16" fill="#F59E0B" stroke="#F59E0B" strokeWidth="2" />
    
    <defs>
      <linearGradient id="linceGradientIcon" x1="0" y1="0" x2="200" y2="200" gradientUnits="userSpaceOnUse">
        <stop stopColor="#6366F1" />
        <stop offset="1" stopColor="#8B5CF6" />
      </linearGradient>
    </defs>
  </svg>
);

// Icon on white background (for light modes)
const LogoIconWhiteBg = ({ size = 200 }) => (
  <svg width={size} height={size} viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="200" height="200" fill="white" rx="20" />
    <g transform="translate(10, 10)">
      <circle cx="90" cy="90" r="85" fill="url(#linceGradientIconW)" />
      
      {/* Lince face */}
      <ellipse cx="90" cy="84" rx="56" ry="44" fill="#D4A574" />
      
      {/* Ear tufts */}
      <path d="M46 40L34 8L60 32Z" fill="#8B5A2B" />
      <path d="M134 40L146 8L120 32Z" fill="#8B5A2B" />
      <path d="M46 40L39 18L55 32Z" fill="#2D1B0E" />
      <path d="M134 40L141 18L125 32Z" fill="#2D1B0E" />
      
      {/* Inner ears */}
      <path d="M49 44L42 22L60 38Z" fill="#F4D6B8" />
      <path d="M131 44L138 22L120 38Z" fill="#F4D6B8" />
      
      {/* Cheek fur */}
      <path d="M32 78Q22 90 27 112Q38 106 44 90Z" fill="#C4956A" />
      <path d="M148 78Q158 90 153 112Q142 106 136 90Z" fill="#C4956A" />
      
      {/* White patches */}
      <ellipse cx="68" cy="78" rx="17" ry="20" fill="#F5E6D3" />
      <ellipse cx="112" cy="78" rx="17" ry="20" fill="#F5E6D3" />
      
      {/* Eyes */}
      <ellipse cx="68" cy="74" rx="11" ry="14" fill="#F59E0B" />
      <ellipse cx="112" cy="74" rx="11" ry="14" fill="#F59E0B" />
      <circle cx="68" cy="74" r="7" fill="#1E293B" />
      <circle cx="112" cy="74" r="7" fill="#1E293B" />
      <circle cx="71" cy="70" r="2.5" fill="white" />
      <circle cx="115" cy="70" r="2.5" fill="white" />
      
      {/* Nose */}
      <path d="M90 92L83 102L90 108L97 102Z" fill="#2D1B0E" />
      
      {/* Mouth */}
      <path d="M90 108V114" stroke="#2D1B0E" strokeWidth="2" strokeLinecap="round" />
      <path d="M78 118Q90 126 102 118" stroke="#2D1B0E" strokeWidth="2" fill="none" strokeLinecap="round" />
      
      {/* Spots */}
      <circle cx="51" cy="66" r="4" fill="#8B5A2B" />
      <circle cx="129" cy="66" r="4" fill="#8B5A2B" />
      <circle cx="56" cy="96" r="2.5" fill="#8B5A2B" />
      <circle cx="124" cy="96" r="2.5" fill="#8B5A2B" />
      
      {/* Whiskers */}
      <path d="M50 98L24 92" stroke="#2D1B0E" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M50 104L20 106" stroke="#2D1B0E" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M50 110L24 122" stroke="#2D1B0E" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M130 98L156 92" stroke="#2D1B0E" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M130 104L160 106" stroke="#2D1B0E" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M130 110L156 122" stroke="#2D1B0E" strokeWidth="1.2" strokeLinecap="round" />
      
      {/* Graduation cap */}
      <path d="M90 22L46 44L90 66L134 44Z" fill="#1E293B" />
      <rect x="82" y="14" width="16" height="14" fill="#F59E0B" />
      <path d="M98 14L108 4L118 14" fill="#F59E0B" stroke="#F59E0B" strokeWidth="2" />
    </g>
    
    <defs>
      <linearGradient id="linceGradientIconW" x1="10" y1="10" x2="190" y2="190" gradientUnits="userSpaceOnUse">
        <stop stopColor="#6366F1" />
        <stop offset="1" stopColor="#8B5CF6" />
      </linearGradient>
    </defs>
  </svg>
);

// Icon on dark background
const LogoIconDarkBg = ({ size = 200 }) => (
  <svg width={size} height={size} viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="200" height="200" fill="#1E293B" rx="20" />
    <g transform="translate(10, 10)">
      <circle cx="90" cy="90" r="85" fill="url(#linceGradientIconD)" />
      
      {/* Lince face */}
      <ellipse cx="90" cy="84" rx="56" ry="44" fill="#D4A574" />
      
      {/* Ear tufts */}
      <path d="M46 40L34 8L60 32Z" fill="#8B5A2B" />
      <path d="M134 40L146 8L120 32Z" fill="#8B5A2B" />
      <path d="M46 40L39 18L55 32Z" fill="#2D1B0E" />
      <path d="M134 40L141 18L125 32Z" fill="#2D1B0E" />
      
      {/* Inner ears */}
      <path d="M49 44L42 22L60 38Z" fill="#F4D6B8" />
      <path d="M131 44L138 22L120 38Z" fill="#F4D6B8" />
      
      {/* Cheek fur */}
      <path d="M32 78Q22 90 27 112Q38 106 44 90Z" fill="#C4956A" />
      <path d="M148 78Q158 90 153 112Q142 106 136 90Z" fill="#C4956A" />
      
      {/* White patches */}
      <ellipse cx="68" cy="78" rx="17" ry="20" fill="#F5E6D3" />
      <ellipse cx="112" cy="78" rx="17" ry="20" fill="#F5E6D3" />
      
      {/* Eyes */}
      <ellipse cx="68" cy="74" rx="11" ry="14" fill="#F59E0B" />
      <ellipse cx="112" cy="74" rx="11" ry="14" fill="#F59E0B" />
      <circle cx="68" cy="74" r="7" fill="#1E293B" />
      <circle cx="112" cy="74" r="7" fill="#1E293B" />
      <circle cx="71" cy="70" r="2.5" fill="white" />
      <circle cx="115" cy="70" r="2.5" fill="white" />
      
      {/* Nose */}
      <path d="M90 92L83 102L90 108L97 102Z" fill="#2D1B0E" />
      
      {/* Mouth */}
      <path d="M90 108V114" stroke="#2D1B0E" strokeWidth="2" strokeLinecap="round" />
      <path d="M78 118Q90 126 102 118" stroke="#2D1B0E" strokeWidth="2" fill="none" strokeLinecap="round" />
      
      {/* Spots */}
      <circle cx="51" cy="66" r="4" fill="#8B5A2B" />
      <circle cx="129" cy="66" r="4" fill="#8B5A2B" />
      <circle cx="56" cy="96" r="2.5" fill="#8B5A2B" />
      <circle cx="124" cy="96" r="2.5" fill="#8B5A2B" />
      
      {/* Whiskers */}
      <path d="M50 98L24 92" stroke="#2D1B0E" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M50 104L20 106" stroke="#2D1B0E" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M50 110L24 122" stroke="#2D1B0E" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M130 98L156 92" stroke="#2D1B0E" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M130 104L160 106" stroke="#2D1B0E" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M130 110L156 122" stroke="#2D1B0E" strokeWidth="1.2" strokeLinecap="round" />
      
      {/* Graduation cap */}
      <path d="M90 22L46 44L90 66L134 44Z" fill="#1E293B" />
      <rect x="82" y="14" width="16" height="14" fill="#F59E0B" />
      <path d="M98 14L108 4L118 14" fill="#F59E0B" stroke="#F59E0B" strokeWidth="2" />
    </g>
    
    <defs>
      <linearGradient id="linceGradientIconD" x1="10" y1="10" x2="190" y2="190" gradientUnits="userSpaceOnUse">
        <stop stopColor="#6366F1" />
        <stop offset="1" stopColor="#8B5CF6" />
      </linearGradient>
    </defs>
  </svg>
);

const LogoDownloadPage = () => {
  const [downloadedItems, setDownloadedItems] = useState({});

  const downloadSVG = (svgElement, filename) => {
    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svgElement);
    const blob = new Blob([svgString], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${filename}.svg`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    setDownloadedItems(prev => ({ ...prev, [`${filename}-svg`]: true }));
    setTimeout(() => setDownloadedItems(prev => ({ ...prev, [`${filename}-svg`]: false })), 2000);
  };

  const downloadPNG = async (svgElement, filename, width, height) => {
    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svgElement);
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    
    const img = new window.Image();
    const svgBlob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);
    
    img.onload = () => {
      ctx.drawImage(img, 0, 0, width, height);
      canvas.toBlob((blob) => {
        const pngUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = pngUrl;
        a.download = `${filename}.png`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(pngUrl);
        URL.revokeObjectURL(url);
        
        setDownloadedItems(prev => ({ ...prev, [`${filename}-png`]: true }));
        setTimeout(() => setDownloadedItems(prev => ({ ...prev, [`${filename}-png`]: false })), 2000);
      }, 'image/png');
    };
    img.src = url;
  };

  const logoVariants = [
    {
      id: 'logo-full',
      name: 'Logo Completo',
      description: 'Logo con icono y texto',
      component: LogoFull,
      width: 800,
      height: 280,
      useCase: 'Ideal para headers, documentos y presentaciones',
    },
    {
      id: 'logo-icon',
      name: 'Icono Solo',
      description: 'Mascota del Lince Ibérico',
      component: LogoIcon,
      width: 500,
      height: 500,
      useCase: 'Perfecto para favicons, avatares y perfiles',
    },
    {
      id: 'logo-icon-white',
      name: 'Icono (Fondo Blanco)',
      description: 'Icono con fondo blanco',
      component: LogoIconWhiteBg,
      width: 500,
      height: 500,
      useCase: 'Para usar sobre fondos oscuros o transparentes',
    },
    {
      id: 'logo-icon-dark',
      name: 'Icono (Fondo Oscuro)',
      description: 'Icono con fondo oscuro',
      component: LogoIconDarkBg,
      width: 500,
      height: 500,
      useCase: 'Para usar sobre fondos claros',
    },
  ];

  const socialMediaSizes = [
    { platform: 'Twitter/X', icon: Twitter, profile: '400x400', banner: '1500x500' },
    { platform: 'Facebook', icon: Facebook, profile: '180x180', cover: '820x312' },
    { platform: 'Instagram', icon: Instagram, profile: '320x320', post: '1080x1080' },
    { platform: 'LinkedIn', icon: Linkedin, profile: '400x400', banner: '1584x396' },
    { platform: 'YouTube', icon: Youtube, profile: '800x800', banner: '2560x1440' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-indigo-900 py-8 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-4 mb-4">
            <LogoIcon size={80} />
            <h1 className="text-4xl font-bold text-white">Kit de Logos TuPlazaIA</h1>
          </div>
          <p className="text-slate-300 text-lg max-w-2xl mx-auto">
            Descarga los logos oficiales en diferentes formatos y tamaños para usar en tus redes sociales, 
            documentos y materiales de marketing.
          </p>
        </div>

        {/* Main Logo Variants */}
        <div className="grid md:grid-cols-2 gap-6 mb-12">
          {logoVariants.map((variant) => {
            const Component = variant.component;
            return (
              <div
                key={variant.id}
                className="bg-white/10 backdrop-blur-lg rounded-2xl p-6 border border-white/20"
              >
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h3 className="text-xl font-semibold text-white">{variant.name}</h3>
                    <p className="text-slate-400 text-sm">{variant.description}</p>
                  </div>
                </div>
                
                {/* Preview */}
                <div className="bg-slate-800/50 rounded-xl p-6 flex items-center justify-center mb-4 min-h-[200px]" 
                     style={{ background: variant.id.includes('white') ? '#1e293b' : variant.id.includes('dark') ? '#f8fafc' : 'rgba(30,41,59,0.5)' }}>
                  <div id={`preview-${variant.id}`}>
                    <Component size={variant.id === 'logo-full' ? 350 : 180} />
                  </div>
                </div>
                
                <p className="text-slate-400 text-sm mb-4">{variant.useCase}</p>
                
                {/* Download Buttons */}
                <div className="flex gap-3">
                  <button
                    onClick={() => {
                      const svgEl = document.querySelector(`#preview-${variant.id} svg`);
                      if (svgEl) downloadSVG(svgEl, `tuplazaia-${variant.id}`);
                    }}
                    className="flex-1 flex items-center justify-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white py-3 px-4 rounded-xl transition-all font-medium"
                    data-testid={`download-svg-${variant.id}`}
                  >
                    {downloadedItems[`tuplazaia-${variant.id}-svg`] ? (
                      <><CheckCircle className="w-5 h-5" /> Descargado</>
                    ) : (
                      <><Download className="w-5 h-5" /> SVG</>
                    )}
                  </button>
                  <button
                    onClick={() => {
                      const svgEl = document.querySelector(`#preview-${variant.id} svg`);
                      if (svgEl) downloadPNG(svgEl, `tuplazaia-${variant.id}`, variant.width, variant.height);
                    }}
                    className="flex-1 flex items-center justify-center gap-2 bg-purple-600 hover:bg-purple-700 text-white py-3 px-4 rounded-xl transition-all font-medium"
                    data-testid={`download-png-${variant.id}`}
                  >
                    {downloadedItems[`tuplazaia-${variant.id}-png`] ? (
                      <><CheckCircle className="w-5 h-5" /> Descargado</>
                    ) : (
                      <><Image className="w-5 h-5" /> PNG</>
                    )}
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        {/* Social Media Sizes Reference */}
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-6 border border-white/20 mb-12">
          <h2 className="text-2xl font-bold text-white mb-6 flex items-center gap-3">
            <Square className="w-6 h-6" />
            Tamaños Recomendados para Redes Sociales
          </h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {socialMediaSizes.map((social) => {
              const IconComponent = social.icon;
              return (
                <div key={social.platform} className="bg-slate-800/50 rounded-xl p-4">
                  <div className="flex items-center gap-3 mb-3">
                    <IconComponent className="w-6 h-6 text-indigo-400" />
                    <span className="text-white font-semibold">{social.platform}</span>
                  </div>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between text-slate-300">
                      <span>Foto de perfil:</span>
                      <span className="text-indigo-300 font-mono">{social.profile}</span>
                    </div>
                    {social.banner && (
                      <div className="flex justify-between text-slate-300">
                        <span>Banner:</span>
                        <span className="text-indigo-300 font-mono">{social.banner}</span>
                      </div>
                    )}
                    {social.cover && (
                      <div className="flex justify-between text-slate-300">
                        <span>Portada:</span>
                        <span className="text-indigo-300 font-mono">{social.cover}</span>
                      </div>
                    )}
                    {social.post && (
                      <div className="flex justify-between text-slate-300">
                        <span>Post cuadrado:</span>
                        <span className="text-indigo-300 font-mono">{social.post}</span>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Tips */}
        <div className="bg-gradient-to-r from-indigo-600/20 to-purple-600/20 rounded-2xl p-6 border border-indigo-500/30">
          <h2 className="text-xl font-bold text-white mb-4">💡 Consejos de Uso</h2>
          <ul className="text-slate-300 space-y-2">
            <li>• <strong>SVG</strong>: Usa este formato para web, ya que es escalable sin pérdida de calidad.</li>
            <li>• <strong>PNG</strong>: Ideal para redes sociales y documentos donde necesitas un archivo de imagen.</li>
            <li>• <strong>Fondo transparente</strong>: El icono solo y el logo completo tienen fondo transparente.</li>
            <li>• <strong>Versiones con fondo</strong>: Usa las versiones con fondo blanco u oscuro cuando necesites contraste.</li>
            <li>• <strong>Redimensionar</strong>: Puedes redimensionar los PNG sin perder mucha calidad si descargas el SVG y usas herramientas como Canva o Figma.</li>
          </ul>
        </div>

        {/* Back button */}
        <div className="mt-8 text-center">
          <a
            href="/dashboard"
            className="inline-flex items-center gap-2 text-indigo-400 hover:text-indigo-300 transition-colors"
            data-testid="back-to-dashboard"
          >
            ← Volver al Dashboard
          </a>
        </div>
      </div>
    </div>
  );
};

export default LogoDownloadPage;
